export const chartdir = [
    // { name: "单列显示", value: "5" },
    // { name: "双列显示", value: "6" },
    // { name: "纵向显示", value: "7" },
    { name: "向下展开", value: "1" },
    { name: "向左展开", value: "4" },
    { name: "向上展开", value: "3" },
    { name: "向右展开", value: "2" },
]

export const getNullDataTips = (type = "err3", info = null) => {

    return {
        type: "err3",
        info: ["暂无数据，请切换查询条件"]
    }

    switch (type) {
        case "err1":
            return {
                type: "err1",
                info: info || ["您没有组织权限,暂时无法查看行政组织结构图。", "如需获取组织权限，请联系管理员"]
            }
        case "err2":
            return {
                type: "err2",
                info: info || ["暂无权限"]
            }
        case "err3":
            return {
                type: "err3",
                info: info || ["暂无数据"]
            }
    }
}

